module.exports = __webpack_public_path__ + "images/Tenable-2cbbec.png";